module.exports = __webpack_public_path__ + "static/media/KalgoorlieMiner-devicecomp-min@2x.87800d4e.webp";